import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "7.5",
  cy: "16.5",
  r: "1.5"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "7.5",
  cy: "7.5",
  r: "1.5"
}, "2"), /*#__PURE__*/_jsx("circle", {
  cx: "12",
  cy: "12",
  r: "1.5"
}, "3"), /*#__PURE__*/_jsx("circle", {
  cx: "16.5",
  cy: "16.5",
  r: "1.5"
}, "4"), /*#__PURE__*/_jsx("circle", {
  cx: "16.5",
  cy: "7.5",
  r: "1.5"
}, "5")], 'CasinoOutlined');